import SessionDetailsItem from "@app.automotus.io/components/SessionDetailsItem";
import React from "react";
import * as Yup from "yup";
import Box from "@mui/material/Box";
import { DatePicker } from "formik-mui-lab";
import { Field } from "formik";

export const CourtDateSessionDetailsItem: React.FC<CourtDateSessionDetailsItemProps> = ({
  loading,
  courtDate,
  skeletonWidth,
  onSubmitEdit,
}) => {
  const initialValues: CourtDateSessionDetailsItemFormValues = {
    courtDate: courtDate || new Date(),
  };

  const validationSchema = Yup.object({
    courtDate: Yup.date().required("Court date is required"),
  });

  return (
    <SessionDetailsItem
      loading={loading}
      title={"Court Date"}
      content={courtDate?.toLocaleDateString() || ""}
      skeletonWidth={skeletonWidth}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmitEdit={onSubmitEdit}
    >
      {({ isSubmitting, errors, touched, setFieldValue }) => (
        <Box sx={{ display: "flex", gap: 2, alignItems: "center", justifyContent: "space-between" }}>
          <Field
            component={DatePicker}
            name="courtDate"
            autoFocus
            fullWidth
            error={touched.courtDate && Boolean(errors.courtDate)}
            helperText={(touched.courtDate && errors.courtDate) || " "}
            disabled={isSubmitting}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFieldValue("courtDate", e);
            }}
          />
        </Box>
      )}
    </SessionDetailsItem>
  );
};

export interface CourtDateSessionDetailsItemFormValues {
  courtDate: Date;
}

export interface CourtDateSessionDetailsItemProps {
  loading?: boolean;
  courtDate?: Date;
  skeletonWidth?: number;
  onSubmitEdit?: (values: CourtDateSessionDetailsItemFormValues) => Promise<void>;
}

export default CourtDateSessionDetailsItem;
